import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImageProps, GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"

const imgQuery = graphql`
  {
    img: file(relativePath: { eq: "Timer/giftPurple.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED)
      }
    }
  }
`

export default function GiftImg(props: Omit<GatsbyImageProps, "image">) {
  const { img } = useStaticQuery(imgQuery)

  return <GatsbyImage loading="eager" {...props} image={getImage(img)!} />
}
